import { Link } from "react-router-dom";
import { MapPin, ArrowRight } from "lucide-react";
import { SectionBadge } from "./Shared";
import { useScrollReveal } from "../lib/hooks";
import { AREA_LINKS } from "../lib/localPages";
import { FONT_HEAD, FONT_BODY, NAVY, GOLD } from "../lib/constants";

const COPY = {
  en: {
    id: "areas",
    badge: "Areas We Serve",
    title: "Areas We Serve",
    text: "Licensed & insured cleaning across Naples and Collier County — plus Marco Island and Bonita Springs.",
    link: "See cleaning services",
  },
  es: {
    id: "zonas",
    badge: "Zonas que atendemos",
    title: "Zonas que atendemos",
    text: "Limpieza con licencia y seguro en Naples y el condado de Collier — además de Marco Island y Bonita Springs.",
    link: "Ver servicios de limpieza",
  },
};

export const AreasSection = ({ lang = "en" }) => {
  const ref = useScrollReveal();
  const c = COPY[lang];
  return (
    <section ref={ref} id={c.id} data-testid={`areas-section-${lang}`} className="py-20 md:py-28 section-hidden" style={{ background: "#F9FAFB" }} lang={lang}>
      <div className="max-w-7xl mx-auto px-4 md:px-8">
        <div className="text-center mb-14">
          <SectionBadge>{c.badge}</SectionBadge>
          <h2 className="text-3xl md:text-4xl font-bold mb-4" style={{ fontFamily: FONT_HEAD, color: NAVY }}>{c.title}</h2>
          <p className="text-base max-w-2xl mx-auto" style={{ color: "#6B7280", fontFamily: FONT_BODY }}>{c.text}</p>
        </div>
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6">
          {AREA_LINKS[lang].map(({ label, to }) => (
            <Link
              key={to}
              to={to}
              data-testid={`area-link-${to.split("/").pop()}`}
              className="group p-6 bg-white flex flex-col gap-4 transition-all duration-300 hover:-translate-y-1 hover:shadow-lg"
              style={{ border: "1px solid rgba(27,58,107,0.1)" }}
            >
              <div className="w-12 h-12 flex items-center justify-center" style={{ background: "rgba(212,168,67,0.12)" }}>
                <MapPin size={22} style={{ color: GOLD }} />
              </div>
              <h3 className="text-lg font-bold" style={{ fontFamily: FONT_HEAD, color: NAVY }}>{label}</h3>
              <span className="inline-flex items-center gap-1.5 text-sm font-bold mt-auto" style={{ color: GOLD, fontFamily: FONT_BODY }}>
                {c.link} <ArrowRight size={14} className="transition-transform group-hover:translate-x-1" />
              </span>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
};
